export default "__VITE_ASSET__DQAtExHY__"